const features = [
  {
    icon: 'ri-shield-check-line',
    title: '纯净无广告',
    desc: '全程无弹窗广告、无强制观看，给你最干净的观影环境。无需付费，无需会员，打开即看。',
    bgClass: 'bg-primary-100',
    iconClass: 'text-primary-500',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速高清播放',
    desc: '多线CDN加速，支持1080P高清画质。智能码率自适应，网络不佳也能流畅播放不卡顿。',
    bgClass: 'bg-accent-100',
    iconClass: 'text-accent-500',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全端无缝体验',
    desc: '电脑、平板、手机全端适配，同一账号同步观看记录。随时随地追剧，不受设备限制。',
    bgClass: 'bg-secondary-100',
    iconClass: 'text-secondary-500',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            为什么选择我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            致力于打造最好的免费影视观看体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl mx-auto">
          {features.map((feature, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200 text-center hover:border-primary-300 transition-colors"
            >
              <div className={`w-14 h-14 mx-auto flex items-center justify-center rounded-2xl ${feature.bgClass} mb-5`}>
                <i className={`${feature.icon} ${feature.iconClass} text-2xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 text-base mb-3">
                {feature.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}